import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "/api";

export type SwiftsellSkuOption = {
  sku: string;
};

export type SwiftsellMaterialOption = {
  sku: string;
  grade: string;
  description: string;
};

export type SwiftsellValidationPair = {
  sku: string;
  fabric: string;
};

export type SwiftsellValidationRow = {
  sku: string;
  fabric: string;
  validSku: boolean;
  validFabric: boolean;
  compatible: boolean;
  resolvedFabric: SwiftsellMaterialOption | null;
};

export type SwiftsellIncompatiblePair = {
  sku: string;
  fabric: string;
  grade: string | null;
};

export type SwiftsellValidationResult = {
  results: SwiftsellValidationRow[];
  invalidSkus: string[];
  invalidFabrics: string[];
  incompatiblePairs: SwiftsellIncompatiblePair[];
};

type ApiResponse<T> = {
  status: "Ok" | "Error";
  data: T;
  messages?: string[];
};

export async function fetchSwiftsellSkus(search: string, effectiveAccountId?: string): Promise<SwiftsellSkuOption[]> {
  const response = await axios.get<ApiResponse<SwiftsellSkuOption[]>>(`${API_URL}/swiftsell/skus`, {
    params: {
      search,
      effectiveAccountId,
      limit: 20,
    },
  });

  return response.data.data;
}

export async function fetchSwiftsellMaterials(
  search = "",
  sku?: string,
  effectiveAccountId?: string
): Promise<SwiftsellMaterialOption[]> {
  const response = await axios.get<ApiResponse<SwiftsellMaterialOption[]>>(`${API_URL}/swiftsell/materials`, {
    params: {
      search,
      sku,
      effectiveAccountId,
      limit: 50,
    },
  });

  return response.data.data;
}

export async function validateSwiftsellProducts(
  pairs: SwiftsellValidationPair[],
  effectiveAccountId?: string
): Promise<SwiftsellValidationResult> {
  const response = await axios.post<ApiResponse<SwiftsellValidationResult>>(`${API_URL}/swiftsell/validate`, {
    pairs,
    effectiveAccountId,
  });

  // Normalize so a partial/older response shape degrades to a clear error rather than a crash.
  const data = response.data.data;
  return {
    results: data?.results ?? [],
    invalidSkus: data?.invalidSkus ?? [],
    invalidFabrics: data?.invalidFabrics ?? [],
    incompatiblePairs: data?.incompatiblePairs ?? [],
  };
}
